<script>
import {
    historyState,
    undoHistory,
    redoHistory,
} from "@app/store/historyStore.svelte.js";
import { isSelectedEventGroupLocked } from "@app/store/eventGroupStore.svelte.js";
import { toast } from "@zerodevx/svelte-toast";
import { environment } from "@app/store/envStore.svelte.js";
import { formatKeyCmd } from "@app/lib/menuShortcutHints.svelte.js";
import MenuItem from "../menu/MenuItem.svelte";
import * as m from "@app/paraglide/messages.js";

let isLocked = $derived(isSelectedEventGroupLocked());
let undoDisabled = $derived(historyState.position <= 1 || isLocked);
let redoDisabled = $derived(
    historyState.position === historyState.actions.length || isLocked,
);
let undoHint = $derived(
    formatKeyCmd(environment.mac ? "Meta(CMD)+KeyZ" : "Ctrl+KeyZ"),
);
let redoHint = $derived(
    formatKeyCmd(
        environment.mac ? "Meta(CMD)+Shift+KeyZ" : "Ctrl+KeyY",
    ),
);

function guardedUndo() {
    if (isSelectedEventGroupLocked()) {
        toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
        return;
    }
    undoHistory();
}

function guardedRedo() {
    if (isSelectedEventGroupLocked()) {
        toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
        return;
    }
    redoHistory();
}
</script>

<MenuItem
    icon="bi-arrow-counterclockwise"
    id="edit-undo"
    shortcutHint={undoHint}
    disabled={undoDisabled}
    disabledReason={isLocked ? m.event_group_locked_toast() : ""}
    onSelect={guardedUndo}>
    {m.common_undo()}
    {#if historyState.position > 1}
        {historyState.actions[historyState.position - 1].name}
    {/if}
</MenuItem>
<MenuItem
    icon="bi-arrow-clockwise"
    id="edit-redo"
    shortcutHint={redoHint}
    disabled={redoDisabled}
    disabledReason={isLocked ? m.event_group_locked_toast() : ""}
    onSelect={guardedRedo}>
    {m.common_redo()}
    {#if historyState.actions.length > historyState.position}
        {historyState.actions[historyState.position].name}
    {/if}
</MenuItem>
